export default "__VITE_ASSET__CS7anjK6__"